<template>
    <div class="sec-cont">
        <Head :title="__('Draft List')" />

        <DataTable :headers="tableHeaders" :data="tableData">
            <!-- Expanded Content Slot -->
            <template #default="{ rowIndex, row }">
                <div class="topics-list px-6 py-4">
                    <div
                        v-for="(topic, topicIndex) in drafts[rowIndex].parsedTopics"
                        :key="topicIndex"
                        class="topic-item mb-4"
                    >
                        <div class="topic-header flex justify-between items-center">
                            <p><strong>{{ topic.name }}</strong></p>
                            <button @click="toggleTopicExpand(rowIndex, topicIndex)">
                                {{ expandedTopics[rowIndex]?.includes(topicIndex) ? "Collapse Points" : "Expand Points" }}
                            </button>
                        </div>
                        <ul
                            v-if="expandedTopics[rowIndex]?.includes(topicIndex)"
                            class="mt-2 pl-4 list-disc"
                        >
                            <li v-for="(point, pointIndex) in topic.points" :key="pointIndex">
                                {{ point }}
                            </li>
                        </ul>
                    </div>
                </div>
            </template>
        </DataTable>
    </div>
</template>

<script>
import { Head } from "@inertiajs/vue3";
import DataTable from "@/Shared/Component/DataTable.vue";
import Layout from '@/Shared/Layout'

export default {
    components: {
        Head,
        DataTable,
    },
    layout: Layout,
    props: {
        drafts: {
            required: true,
            type: Array,
        },
    },
    data() {
        return {
            tableHeaders: ["Title", "Activity Type", "First Topic", "Toggle Details", "Action"],
            expandedTopics: {},
        };
    },
    computed: {
        tableData() {
            console.log(this.drafts)
            return this.drafts.map((draft, draftIndex) => {
                return [
                    { value: draft.title }, // Title
                    { value: draft.event_category.name }, // Activity Type
                    { value: draft.parsedTopics?.[0]?.name || "No Topics Available" }, // First topic name or fallback
                    { isAction: true, label: "Expand Topics", action: "toggleExpand" },
                    { value:draft.id, isAction: true, label: "Edit", action: "edit", path:"/admin/draft/"},
                ];
            });
        },
    },
    mounted() {
        // Ensure parsedTopics are available and parsed
        this.drafts.forEach((draft) => {
            draft.parsedTopics =
                typeof draft.topics === "string" ? JSON.parse(draft.topics) : draft.topics || [];
        });
        console.log(  this.drafts)
    },
    methods: {
        toggleTopicExpand(draftIndex, topicIndex) {
            // Initialize expandedTopics for the given draft index if not already
            if (!this.expandedTopics[draftIndex]) {
                this.expandedTopics[draftIndex] = [];
            }

            const expanded = this.expandedTopics[draftIndex];

            // Check if the topic is already expanded, if so, collapse it
            if (expanded.includes(topicIndex)) {
                this.expandedTopics[draftIndex] = expanded.filter((i) => i !== topicIndex);
            } else {
                // If not, expand it by adding the topic index
                expanded.push(topicIndex);
            }
        },
    },
};
</script>
